export class CycleConfigModel {

    /**
     * Math multiplier
     */
    math_multiplier: bigint = BigInt(1000000000);

    /**
     * Percentage divider
     */
    percentage_divider: bigint = BigInt(1000);

    /**
     * Rollover percentage
     */
    rollover_percentage: bigint = BigInt(100);

    /**
     * Cycle timer
     */
    cycle_timer: bigint = BigInt(86400000);

    /**
     * Stake min amount
     */
    stake_min_amount: bigint = BigInt(1000000000);

    /**
     * Stake max amount
     */
    stake_max_amount: bigint = BigInt(1000000000000000);
}